import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

const SplitOperationTableHeader: FC = () => {
  const { t } = useTranslate();

  return (
    <thead>
      <tr className="nk-tb-item tb-tnx-head">
        <th className="nk-tb-col text-left">{t('Partner')}</th>
        <th className="nk-tb-col text-right">{t('PreviousShares')}</th>
        <th className="nk-tb-col text-right">{t('NewShares')}</th>
      </tr>
    </thead>
  );
};

export default SplitOperationTableHeader;
